import React from "react";
import axios from "axios";
import { navigate } from "gatsby";
import { useDispatch } from "react-redux";
import { useAuth, useRegisterModal, useRoutes } from "../../../hooks/redux";
import { logOut } from "../../../state/actions";
import Button from "../../atoms/Button/Button";
import PlainText from "../../atoms/PlainText/PlainText";
import Icon from "../../atoms/Icon/Icon";

export const FavoriteButton = ({ route, classes, label }) => {
    const dispatch = useDispatch();
    const [auth, { updateFavorites }] = useAuth();
    const [routes, { setRoute }] = useRoutes();
    const [modal, { showRegisterModal, setUrlRegisterModal }] =
        useRegisterModal();

    const isRouteFavorited = (id) =>
        auth?.data?.favorites?.includes(id) ?? false;

    const onFavoriteClick = (id) => async () => {
        if (auth.isLoggedIn) {
            if (isRouteFavorited(id)) {
                try {
                    const response = await axios.delete(
                        `${process.env.STRAPI_API_URL}/users/me/favorites/${id}`,
                        {
                            headers: {
                                Authorization: `Bearer ${auth.data.jwt}`,
                            },
                        }
                    );

                    setRoute(response.data.route);
                    updateFavorites(response.data.user.favorites);
                } catch (error) {
                    console.log(error);
                    const { status } = error.response;

                    if (status === 401 || status === 403 || status === 405) {
                        dispatch(logOut());
                        navigate("/app/logowanie");
                    }
                }
            } else {
                try {
                    const response = await axios.post(
                        `${process.env.STRAPI_API_URL}/users/me/favorites/${id}`,
                        {},
                        {
                            headers: {
                                Authorization: `Bearer ${auth.data.jwt}`,
                            },
                        }
                    );

                    setRoute(response.data.route);
                    updateFavorites(response.data.user.favorites);
                } catch (error) {
                    console.log(error);
                    const { status } = error.response;

                    if (status === 401 || status === 403 || status === 405) {
                        dispatch(logOut());
                        navigate("/app/logowanie");
                    }
                }
            }
        } else {
            setUrlRegisterModal("");
            showRegisterModal();
        }
    };

    return (
        <>
            <Button
                className={classes}
                onClick={onFavoriteClick(route?.id)}
                aria-label={`Licznik polubień: ${route?.favoritescount}`}
            >
                <Icon
                    className={
                        isRouteFavorited(route?.id)
                            ? "icon-heart-filled-min favorited"
                            : "icon-heart-min"
                    }
                />
                {label === "inside" && (
                    <PlainText className="btn--label">
                        {route?.favoritescount}
                    </PlainText>
                )}
            </Button>
            {label === "outside" && (
                <PlainText className="btn--label">
                    {route?.favoritescount}
                </PlainText>
            )}
        </>
    );
};

export default FavoriteButton;
